module.exports = __webpack_public_path__ + "static/assets/aa741609c039853216183573e5984cb5.png";